module.exports = __webpack_public_path__ + "static/media/Video_Monitoring.40ee5d85.png";